"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("../../typeAssertions/valueIsArray"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const GeoFire_1 = __importDefault(require("../utils/GeoFire"));
const appStateSelectProjectId_1 = __importDefault(require("../../shared/appStateSelectProjectId"));
const callableGeoFireGetBuilder = async ({ functionId, callbacks, executeProcesses, processor, entryVars: { keyLocation, groupName, }, store, }) => {
    try {
        const projectId = (0, appStateSelectProjectId_1.default)(store.getState());
        const appGeofireDbRef = groupName
            ? processor.root.firebase.database().ref(`projects/${projectId}/geoFireGroups/${groupName}`)
            : processor.root.firebase.database().ref(`projects/${projectId}/geoFire`);
        const geoFire = new GeoFire_1.default(appGeofireDbRef);
        const infoGeoFire = await geoFire.get(keyLocation);
        if (!(0, valueIsRecord_1.default)(infoGeoFire)
            || !(0, valueIsArray_1.default)(infoGeoFire.location)) {
            executeProcesses(undefined, callbacks.noDataProcess);
            return;
        }
        executeProcesses(functionId, callbacks.successProcess, {
            latitude: infoGeoFire.location[0],
            longitude: infoGeoFire.location[1],
            data: infoGeoFire.data,
        });
    }
    catch (e) {
        executeProcesses(functionId, callbacks.errorProcess, e);
    }
};
exports.default = callableGeoFireGetBuilder;
